import { render, staticRenderFns } from "./address-label.vue?vue&type=template&id=f7924b4a"
import script from "./address-label.vue?vue&type=script&lang=js"
export * from "./address-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports